import { clsx } from 'clsx';
import Skeleton from '../atoms/Skeleton';
import './DataTableSkeleton.scss';

interface IDataTableSkeletonProps {
    fillHeight?: boolean;
    showBar?: boolean;
    paging?: boolean;
}

// Лёгкий каркас доступен до загрузки DataTable и используется самой таблицей:
// переход от lazy-страницы к ожиданию схемы сохраняет одну раскладку.
const DataTableSkeleton = ({ fillHeight = false, showBar = true, paging = true }: IDataTableSkeletonProps) => {
    // Полноэкранный список заполняет высоту; встроенная таблица держит короткий блок.
    const skeletonRows = fillHeight ? 14 : 4;
    return (
        <div className={clsx('dtb__skeleton', fillHeight && 'dtb__skeleton--fill')} aria-hidden>
            {/* Каркас повторяет готовую таблицу блок в блок: полоса
                туллбара (поиск слева, кнопки справа), зона с шапкой
                колонок и плитками строк, футер пейджера. Размеры и
                радиусы — те же, что у настоящих контролов, иначе на
                подмене каркаса реальным списком всё «прыгает». */}
            {showBar && (
                <div className="dtb__skeleton-bar">
                    <Skeleton height={36} width={360} radius={11} />
                    <span className="dtb__skeleton-gap" />
                    {Array.from({ length: 4 }, (_, i) => (
                        <Skeleton key={i} height={36} width={36} radius={11} />
                    ))}
                </div>
            )}
            <div className="dtb__skeleton-zone">
                <div className="dtb__skeleton-head">
                    {Array.from({ length: 5 }, (_, i) => (
                        <Skeleton key={i} height={11} radius={6} />
                    ))}
                </div>
                <div className="dtb__skeleton-rows">
                    {Array.from({ length: skeletonRows }, (_, i) => (
                        <Skeleton key={i} height={39} radius={14} />
                    ))}
                </div>
            </div>
            {paging && (
                <div className="dtb__skeleton-foot">
                    <Skeleton height={28} width={130} radius={10} />
                    <Skeleton height={14} width={170} radius={7} />
                    <Skeleton height={28} width={210} radius={10} />
                </div>
            )}
        </div>
    );
};

export default DataTableSkeleton;
